import JSEncrypt from "jsencrypt";

const publicKey = `
-----BEGIN PUBLIC KEY-----
${process.env.REACT_APP_PUBLIC_KEY}
-----END PUBLIC KEY-----`;
const encryptor = new JSEncrypt();
encryptor.setPublicKey(publicKey);
export default encryptor;
